import { render } from "./imageviewer.vue?vue&type=template&id=854f35ea&scoped=true"
import script from "./imageviewer.vue?vue&type=script&lang=js"
export * from "./imageviewer.vue?vue&type=script&lang=js"

import "./imageviewer.vue?vue&type=style&index=0&id=854f35ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-854f35ea"]])

export default __exports__